import { connectionManager, ConnectionState } from './connection'
import { isNetworkError } from './utils'

const IDEMPOTENT_METHODS = ['get', 'head', 'options']
const MAX_RETRIES = 2
const BASE_DELAY_MS = 1000

const isIdempotent = config => IDEMPOTENT_METHODS.includes((config?.method || '').toLowerCase())
const backoffDelay = attempt => BASE_DELAY_MS * Math.pow(2, attempt - 1)
const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

export const attachRetryInterceptor = axios => {
  axios.interceptors.response.use(
    response => {
      connectionManager.setState(ConnectionState.CONNECTED)
      return response
    },
    async error => {
      const { config } = error

      if (!config || !isNetworkError(error) || !isIdempotent(config)) {
        return Promise.reject(error)
      }

      config.__retryCount = (config.__retryCount || 0) + 1

      if (config.__retryCount > MAX_RETRIES) {
        connectionManager.setState(ConnectionState.OFFLINE)
        return Promise.reject(error)
      }

      connectionManager.setState(ConnectionState.RECONNECTING)
      await wait(backoffDelay(config.__retryCount))
      return axios(config)
    }
  )
}
